import React, { useEffect } from 'react'
import SidebarItems from './SidebarItems'
import { Sidebar, SidebarContent, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/Components/ui/sidebar'
import { Link } from 'react-router-dom'
import assets from '@/assets/assets'
import SidebarMenuData from '@/assets/data/SideBarMenu'
import { useAuth } from '@/Context/AuthContext'

const PageSidebar = (props) => {
    const { userInfo } = useAuth()
    return (
        <Sidebar {...props}>
            <SidebarHeader className="bg-primary-purpal">
                <SidebarMenu>
                    <SidebarMenuItem>
                        <SidebarMenuButton size="lg" className="hover:bg-transparent active:bg-transparent" asChild>
                            <Link to="/" className="flex justify-start ">
                                <img src={assets.redroadwhitelogo} alt="Logo" className="w-36" />
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarHeader>
            <SidebarContent className="section-grad-sidebar overflow-card-scroll-sidebar">
                <SidebarItems items={SidebarMenuData.navMain} userInfo={userInfo} />
            </SidebarContent>
        </Sidebar>
    )
}

export default PageSidebar
